export const isMac =
  typeof navigator !== "undefined" &&
  ((navigator as Navigator & { userAgentData?: { platform: string } }).userAgentData?.platform === "macOS" ||
    /Mac|iPod|iPhone|iPad/.test(navigator.platform));
